var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"source-echart"},[_c('div',{staticClass:"source-pie",attrs:{"id":'source'+_vm.timeId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }